import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { postTypeForCategory } from '../lib/cms'
import { api, type AdminPost } from './api'

export default function AdminLegacyPostRedirect() {
  const { id } = useParams()
  const [to, setTo] = useState<string | null>(null)

  useEffect(() => {
    if (!id) return
    api<AdminPost>(`/api/admin/posts/${id}`)
      .then((post) => setTo(`/admin/${postTypeForCategory(post.category).slug}/${post.id}`))
      .catch(() => setTo('/admin'))
  }, [id])

  if (!to) return <p className="text-muted">Loading…</p>
  return <Navigate to={to} replace />
}
